module.exports = __webpack_public_path__ + "static/media/launch.5e41b56d.svg";